import { render, staticRenderFns } from "./Quest.vue?vue&type=template&id=67845346&"
import script from "./Quest.vue?vue&type=script&lang=js&"
export * from "./Quest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports